/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Component } from 'react';

import { UpgradeSmartComponentConnected as UpgradeSmartComponent } from '@trello/billing/upgrade-prompts';
import { dontUpsell } from '@trello/browser';

import { Auth } from 'app/scripts/db/Auth';
import { pluginsChangedSignal } from 'app/scripts/views/internal/plugins/PluginsChangedSignal';
import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { BaseDirectoryView } from './BaseDirectoryView';
const t = recupWithHelpers('directory');

class DirectoryBusinessClassBanner extends Component {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Dir... Remove this comment to see the full error message
    this.prototype.displayName = 'Directory Business Class Banner';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.prototype.render = t.renderable(function (this: any) {
      const { onDismissClick, orgId } = this.props;

      return t.div('.directory-business-class-banner', function () {
        t.div('.banner-content', function () {
          t.icon('business-class', { class: 'icon-lg light' });
          return t.format(
            'this-board-has-reached-its-power-up-limit-upgrade-to-business-class-to-enable-additional-power-ups',
          );
        });
        return t.div('.buttons-container', function () {
          t.a('.dismiss-link', { href: '#', onClick: onDismissClick }, () =>
            t.format('dismiss'),
          );
          return t.addElement(
            <UpgradeSmartComponent
              orgId={orgId}
              promptId="pupUpgradeBannerButton"
            />,
          );
        });
      });
    });
  }
}

DirectoryBusinessClassBanner.initClass();

class DirectoryHeader extends Component {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Dir... Remove this comment to see the full error message
    this.prototype.displayName = 'Directory Header';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.prototype.render = t.renderable(function (this: any) {
      const { title, showBackButton, navigateBack, toggleNavigationMenu } =
        this.props;

      return t.div('.directory-header', () =>
        t.div('.directory-header-toolbar', function () {
          t.h2('.directory-header-toolbar-title', () => t.format(title));
          t.div('.directory-header-toolbar-left', function () {
            t.a('.icon-lg.icon-back.dark-hover.directory-back-btn', {
              href: '#',
              onClick: navigateBack,
              class: t.classify({ hide: !showBackButton }),
            });
            return t.a(
              '.directory-hamburger',
              { href: '#', onClick: toggleNavigationMenu },
              () => t.text('☰'),
            );
          });
          return t.div('.directory-header-toolbar-right', () =>
            t.a('.icon-lg.icon-close.dark-hover.js-close-directory', {
              href: '#',
            }),
          );
        }),
      );
    });
  }
}

DirectoryHeader.initClass();

class DirectoryHeaderComponent extends Component {
  static initClass() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.prototype.render = t.renderable(function (this: any) {
      const {
        title,
        showBackButton,
        navigateBack,
        toggleNavigationMenu,
        upsellEnabled,
        onDismissClick,
        orgId,
      } = this.props;
      return t.div(function () {
        t.tag(DirectoryHeader, {
          title,
          showBackButton,
          navigateBack,
          toggleNavigationMenu,
        });
        if (upsellEnabled) {
          return t.tag(DirectoryBusinessClassBanner, {
            onDismissClick,
            orgId,
          });
        }
      });
    });
  }
}

DirectoryHeaderComponent.initClass();

// @ts-expect-error
interface DirectoryHeaderView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  directoryView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  manuallyDismissed: any;
}

class DirectoryHeaderView extends BaseDirectoryView {
  // @ts-expect-error TS(2416): Property 'initialize' in type 'DirectoryHeaderView... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ directoryView }: any) {
    this.directoryView = directoryView;
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.initialize(...arguments);
    this.listenTo(this.model, { 'change:powerUps': this.render });
    this.listenTo(this.model.boardPluginList, {
      'add remove reset': this.render,
    });
    return this.subscribe(pluginsChangedSignal(this.model), () =>
      this.render(),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDismissClick(e: any) {
    stopPropagationAndPreventDefault(e);

    Auth.me().dismissAd('DirectoryBusinessClassBanner');
    this.manuallyDismissed = true;
    this.render();
    return this.directoryView.setBodyHeight(this.manuallyDismissed);
  }

  renderContent() {
    const { category, section, idPlugin, history, search } = this.directoryView;

    let title = 'power-ups';
    if (search?.length) {
      title = 'power-ups';
    } else if (category != null) {
      title = category;
    } else if (section != null) {
      title = section;
    }

    // Specifically checking for BC2 orgs to not show upsell banner
    const isPaidOrg = this.model.getOrganization()?.hasPaidProduct();

    return (
      <DirectoryHeaderComponent
        // @ts-expect-error TS(2769): No overload matches this call.
        title={title}
        upsellEnabled={
          !this.model.canEnableAdditionalPowerUps() &&
          !isPaidOrg &&
          !(
            this.manuallyDismissed ||
            Auth.me().isAdDismissed('DirectoryBusinessClassBanner')
          ) &&
          !dontUpsell()
        }
        showBackButton={section != null || idPlugin != null || history.length}
        // eslint-disable-next-line react/jsx-no-bind
        navigateBack={() => this.directoryView.navigateBack()}
        /* eslint-disable-next-line react/jsx-no-bind, @typescript-eslint/no-explicit-any */
        onDismissClick={(e: any) => this.onDismissClick(e)}
        // eslint-disable-next-line react/jsx-no-bind
        toggleNavigationMenu={() => this.directoryView.toggleNavigationMenu()}
        orgId={this.model.getOrganization()?.id}
      />
    );
  }
}

export { DirectoryHeaderView };
